import useSWR from "swr";

import React, { useState } from "react";

import moment from "moment";
import { twMerge } from "tailwind-merge";

import CustomCard from "components/CustomCard";
import { Loader } from "components/customElements/loader";
import SegmentTabs from "components/SegmentTabs";
import { ApiEndpoint, baseFetcher } from "utils/baseFetcher";

import MostDiscussedSnippet from "./MostDiscussedSnippet";
import style from "./style.module.scss";

export const getMostDiscussedUrl = (type: string) => {
  const url = new ApiEndpoint(`/api/v2/${type}`);
  const date = moment().subtract(7, "days").format("YYYY-MM-DD");

  url.searchParams.append("filter[most-discussed-since]", date);
  url.searchParams.append("page[size]", "8");
  type === "insights" && url.searchParams.append("include", "account");

  return url.href;
};

type TabType = "insights" | "entities";

const MostDiscussedWidget = ({
  hideTabs,
  title,
  defaultTab,
}: {
  hideTabs?: boolean;
  title?: string;
  defaultTab?: TabType;
}) => {
  const [active, setActive] = useState<TabType>(defaultTab || "insights");

  const { data, isLoading } = useSWR(getMostDiscussedUrl(active), baseFetcher);

  return (
    <CustomCard className={"p-[15px]"}>
      <div className={twMerge("font-medium text-[16px]")}>
        {title || "Most Discussed"}
      </div>
      <div className={style.tabs}>
        {!hideTabs && (
          <SegmentTabs
            tabs={[
              {
                title: "Insights",
                id: "insights",
              },
              {
                title: "Entities",
                id: "entities",
              },
            ]}
            activeTabId={active}
            onChangeTab={(tab) => setActive(tab.id)}
            className="mt-[10px] mb-[10px]"
          />
        )}
        {isLoading && <Loader numberOfItems={8} />}
        {data?.data.map((item: any) => {
          return (
            <MostDiscussedSnippet key={item?.id} type={active} item={item} />
          );
        })}
      </div>
    </CustomCard>
  );
};

export default MostDiscussedWidget;
